const productData = [
  {
    id: 1,
    name: "Petoutlet Tri-Flex Fetch Ball Dog Toy",
    category: "Toys",
    price: "72.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/petoutlet-01-front.png",
    images: ["/img/petoutlet-01-front.png", "/img/petoutlet-01-angle.png"],
    size: ["S", "M", "L", "XL"],
    colors: ["Blue", "Orange"],
    material: "Natural rubber",
    description: [
      "The Petoutlet Tri-Flex Fetch Ball is a high-performance toy designed for dogs who love to chase, retrieve, and play.",
      "Made from natural rubber, the Tri-Flex ball offers an energetic bounce and durable construction for repeated supervised play.",
      "The vibrant blue and orange colors are highly visible outdoors, making it easy for dogs to spot the ball on grass, dirt, or in water.",
      "Its rounded shape works well for hand-thrown games and compatible standard-size launchers.",
      "The smooth, non-abrasive surface is gentle on a dog's teeth and gums during fetch and chewing sessions.",
      "Available in multiple sizes to suit small, medium, and large breeds for safe and enjoyable play.",
    ],
    Features: [
      "High-bounce natural rubber construction for exciting fetch games",
      "Vibrant colors for maximum visibility on any terrain",
      "Works with compatible standard-size ball launchers",
      "Non-abrasive surface safe for teeth and gums",
      "Available in multiple sizes for all dog breeds",
      "Durable construction withstands aggressive chewing",
    ],
  },
  {
    id: 2,
    name: "Petoutlet Squeak Core Fetch Ball",
    category: "Toys",
    price: "49.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/petoutlet-02-front.png",
    images: ["/img/petoutlet-02-front.png", "/img/petoutlet-02-angle.png"],
    size: ["S", "M", "L", "XL"],
    colors: ["Blue", "Green"],
    material: "Natural rubber with squeaker",
    description: [
      "The Petoutlet Squeak Core Fetch Ball combines an engaging squeak with a resilient, high-bounce design.",
      "The built-in squeaker creates a satisfying sound that keeps dogs engaged and motivated to fetch again and again.",
      "Constructed from natural rubber, this ball maintains its shape and bounce even after extended use and rough play.",
      "The bright blue and green colors ensure the ball is easy to locate during outdoor play sessions in any lighting.",
      "Perfect for interactive play between dogs and their owners, encouraging exercise and mental stimulation.",
      "The squeaker is securely encased within the ball to prevent it from being removed during play.",
    ],
    Features: [
      "Built-in squeaker for added excitement and engagement",
      "Natural rubber construction for long-lasting bounce and durability",
      "Bright colors for easy visibility during outdoor play",
      "Squeaker securely encased to withstand rough handling",
      "Promotes interactive play and exercise",
      "Works with compatible standard-size ball launchers",
    ],
  },
  {
    id: 3,
    name: "Petoutlet Treat-Weave Roller Dog Toy",
    category: "Toys",
    price: "81.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/petoutlet-03-front.png",
    images: ["/img/petoutlet-03-front.png", "/img/petoutlet-03-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Blue", "Pink", "Purple"],
    material: "Non-toxic rubber",
    description: [
      "The Petoutlet Treat-Weave Roller is a versatile cylindrical dog toy that can hold suitable treats or fillings for supervised enrichment.",
      "Made from non-toxic, durable rubber, this toy is designed to withstand enthusiastic chewing while remaining gentle on teeth.",
      "The hollow interior allows for stuffing with treats or frozen snacks, providing both mental stimulation and a satisfying challenge.",
      "Dogs can push, roll, and chew the Treat-Weave Roller for both physical activity and mental enrichment.",
      "The flexible rubber material makes it easy to clean and resistant to damage from saliva and outdoor elements.",
      "Available in multiple sizes to accommodate different dog breeds and chewing strengths.",
    ],
    Features: [
      "Hollow cylindrical design ideal for stuffing with treats or peanut butter",
      "Non-toxic, durable rubber construction withstands chewing",
      "Provides mental stimulation through puzzle-like play",
      "Can be frozen for a refreshing summer treat toy",
      "Easy to clean and maintain",
      "Available in multiple sizes for all dog breeds",
    ],
  },
  {
    id: 4,
    name: "Petoutlet Traveler Ventilated Kennel",
    category: "Kennels",
    price: "563.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/petoutlet-04-front.png",
    images: ["/img/petoutlet-04-front.png", "/img/petoutlet-04-angle.png"],
    size: ["Small", "Medium", "Large", "X-Large"],
    colors: ["Gray", "Tan"],
    material: "Durable plastic with metal door",
    description: [
      "The Petoutlet Traveler Ventilated Kennel is a comfortable carrier designed for secure everyday pet transport.",
      "Constructed from durable, lightweight plastic with a sturdy metal front door for maximum ventilation and security.",
      "For air travel, always confirm current carrier requirements directly with your airline before departure.",
      "The ventilated design features generous airflow openings and a secure locking mechanism for comfortable transport.",
      "Easy to assemble and disassemble without tools, making it convenient for storage and travel setup.",
      "The durable construction protects pets during transit while the ventilation design ensures proper airflow throughout the journey.",
    ],
    Features: [
      "Durable plastic construction for routine pet transport",
      "Sturdy metal front door with secure locking mechanism",
      "Adjustable ventilation panels for optimal airflow",
      "Easy tool-free assembly and disassembly",
      "Available in multiple sizes for different pet breeds",
      "Comfortable interior space for pets during travel",
    ],
  },
  {
    id: 5,
    name: "Petoutlet Airflow Fetch Ball",
    category: "Toys",
    price: "80.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/petoutlet-05-front.png",
    images: ["/img/petoutlet-05-front.png", "/img/petoutlet-05-angle.png"],
    size: ["S", "M", "L", "XL"],
    colors: ["Blue", "Orange"],
    material: "Lightweight foam rubber",
    description: [
      "The Petoutlet Airflow Fetch Ball is a lightweight, ventilated ball designed for supervised indoor and outdoor fetch games.",
      "Its reduced weight makes it ideal for indoor play, reducing the risk of damage to furniture and valuables while still providing satisfying bounce.",
      "Made from durable foam rubber, the Air Fetch Ball maintains its shape and bounce through countless play sessions.",
      "The bright colors ensure high visibility during outdoor play, whether in the backyard, park, or at the beach.",
      "Its open construction is easy to grip and works with compatible standard-size launchers.",
      "An excellent choice for dogs of all sizes and energy levels, providing a safe and fun way to burn off energy.",
    ],
    Features: [
      "Lightweight foam rubber construction safe for indoor play",
      "Bright colors for easy visibility outdoors",
      "Works with compatible standard-size ball launchers",
      "Durable bounce that lasts through many play sessions",
      "Available in multiple sizes for all dog breeds",
      "Reduces risk of furniture damage during indoor fetch",
    ],
  },
  {
    id: 6,
    name: "Petoutlet NightGlow Fetch Ball",
    category: "Toys",
    price: "65.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/petoutlet-06-front.png",
    images: ["/img/petoutlet-06-front.png", "/img/petoutlet-06-angle.png"],
    size: ["S", "M", "L", "XL"],
    colors: ["Green", "Yellow"],
    material: "Glow-in-the-dark rubber",
    description: [
      "The Petoutlet NightGlow Fetch Ball is a glow-in-the-dark toy for supervised fetch sessions in dim conditions.",
      "The special glow material charges under sunlight or indoor light and emits a bright glow during evening or early morning play sessions.",
      "Made from durable rubber, the NightGlow ball maintains its shape and bounce through repeated play.",
      "Perfect for early morning walks, evening park sessions, or any low-light play situation where visibility is reduced.",
      "The vibrant green and yellow colors ensure high visibility during both day and night play.",
      "An excellent way to keep active dogs entertained and exercised regardless of the time of day.",
    ],
    Features: [
      "Glow-in-the-dark material for evening and low-light play",
      "Durable rubber construction for long-lasting use",
      "Bright green and yellow colors for high visibility",
      "Easy to charge with natural or indoor light",
      "Available in multiple sizes for all dog breeds",
      "Perfect for early morning or evening fetch sessions",
    ],
  },
  {
    id: 7,
    name: "Petoutlet FreshLock Storage Lids",
    category: "Food Storage",
    price: "137.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/petoutlet-07-front.png",
    images: ["/img/petoutlet-07-front.png", "/img/petoutlet-07-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Black", "Gray"],
    material: "Airtight plastic with silicone seal",
    description: [
      "Petoutlet FreshLock Storage Lids are airtight lids designed to help keep dry pet food fresh for longer.",
      "Featuring an innovative sealing technology, these lids create an airtight barrier that locks out moisture, pests, and humidity.",
      "The secure seal helps preserve the nutritional value of pet food by preventing oxidation and maintaining optimal freshness.",
      "Compatible with a variety of standard-sized food storage containers, making them a versatile addition to any pet food storage setup.",
      "Easy-grip fins make the FreshLock lids convenient to open and close during daily feeding.",
      "The durable construction ensures long-lasting use, reducing the need for frequent lid replacements.",
    ],
    Features: [
      "Airtight seal locks in freshness and keeps food fresher longer",
      "Moisture and pest barrier protection",
      "One-handed easy open and close operation",
      "Compatible with standard food storage containers",
      "Durable construction for long-lasting performance",
      "Helps maintain nutritional value of pet food",
    ],
  },
  {
    id: 8,
    name: "Petoutlet Fetch Ball Storage Bucket",
    category: "Toys",
    price: "257.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/petoutlet-08-front.png",
    images: ["/img/petoutlet-08-front.png", "/img/petoutlet-08-angle.png"],
    size: ["One size"],
    colors: ["Blue", "Orange"],
    material: "Durable plastic bucket with rubber balls",
    description: [
      "The Petoutlet Fetch Ball Storage Bucket is a complete play set with a navy bucket, coral handle, secure lid, and six colorful fetch balls.",
      "The bucket serves as a convenient storage solution for keeping fetch balls organized and contained when not in use.",
      "The included balls are made from natural rubber and provide lively bounce for supervised fetch games.",
      "The bucket's vibrant blue and orange design is both functional and eye-catching, making it easy to spot in the backyard or at the park.",
      "With six balls included, dogs can enjoy longer fetch sessions without the need to repeatedly throw a single ball.",
      "The bucket's lid securely closes to protect the balls from dirt, debris, and outdoor elements when stored outside.",
    ],
    Features: [
      "Complete set with 6 high-bounce Ultra Balls included",
      "Stylish blue bucket with orange handle and lid for easy storage",
      "Keeps fetch balls organized and protected from the elements",
      "Ideal for extended fetch sessions with multiple balls",
      "Durable construction withstands outdoor use",
      "Vibrant colors ensure high visibility during play",
    ],
  },
  {
    id: 9,
    name: "Petoutlet Big Blue Bowl",
    category: "Bowls",
    price: "241.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/petoutlet-09-front.png",
    images: ["/img/petoutlet-09-front.png", "/img/petoutlet-09-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Blue", "White"],
    material: "Food-safe durable plastic",
    description: [
      "The Petoutlet Big Blue Bowl is a generously sized feeding bowl designed to hold ample portions of food or water for medium to large dogs.",
      "Constructed from food-safe, durable plastic, this bowl is built to withstand daily use and is easy to clean between feedings.",
      "The deep design helps contain food and water more effectively, reducing spillage on floors and surrounding areas.",
      "The vibrant blue color is both visually appealing and easy to locate, making it a practical addition to any pet feeding station.",
      "Dishwasher safe for convenient cleaning, ensuring proper hygiene with minimal effort.",
      "A reliable everyday bowl that combines functionality with the trusted Petoutlet quality.",
    ],
    Features: [
      "Generous capacity suitable for medium to large dogs",
      "Food-safe durable plastic construction",
      "Deep design reduces spillage and mess",
      "Dishwasher safe for easy cleaning",
      "Vibrant blue color for easy visibility",
      "Built to withstand daily use and rough handling",
    ],
  },
  {
    id: 10,
    name: "Petoutlet Long-Reach Ball Launcher",
    category: "Toys",
    price: "89.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/petoutlet-10-front.png",
    images: ["/img/petoutlet-10-front.png", "/img/petoutlet-10-angle.png"],
    size: ["Standard", "Large"],
    colors: ["Blue", "Orange"],
    material: "Ergonomic plastic with rubber grip",
    description: [
      "The Petoutlet Long-Reach Ball Launcher is a hand-held fetch tool designed to extend throwing distance with less bending and reaching.",
      "The ergonomic handle and trigger mechanism allow for comfortable one-handed use, making fetch games easier and more enjoyable for owners.",
      "The launcher is designed for compatible standard-size fetch balls and helps owners create longer throws with a smooth motion.",
      "The lightweight yet sturdy plastic construction ensures durability during outdoor use in all weather conditions.",
      "The launcher keeps hands clean and away from slobbery balls, making it a hygienic and convenient solution for active play.",
      "A practical choice for energetic dogs, the Long-Reach Launcher makes supervised fetch more comfortable for pet and owner.",
    ],
    Features: [
      "Extends throwing distance with a smooth throwing motion",
      "Ergonomic handle for comfortable, one-handed operation",
      "Keeps hands clean and away from slobbery balls",
      "Compatible with standard-size fetch balls",
      "Lightweight and durable for outdoor use",
      "Provides exercise for both dog and owner",
    ],
  },
  {
    id: 11,
    name: "Petoutlet Top-Load Kennel For Cats",
    category: "Kennels",
    price: "482.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/petoutlet-11-front.png",
    images: ["/img/petoutlet-11-front.png", "/img/petoutlet-11-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Gray", "Black"],
    material: "Durable plastic with ventilation panels",
    description: [
      "The Petoutlet Top-Load Kennel for Cats is a practical carrier with a wide top-entry opening for easier loading and unloading.",
      "The rounded dome shape provides a more comfortable and less claustrophobic interior space for cats during transport.",
      "Constructed from durable plastic with multiple ventilation panels to ensure proper airflow and keep cats cool and comfortable.",
      "The top-load design provides an alternative to guiding a hesitant cat through the smaller front door.",
      "Secure latching mechanisms ensure the kennel stays firmly closed during transport, providing peace of mind for pet parents.",
      "Always check the carrier dimensions and current rules with your transport provider before travel.",
    ],
    Features: [
      "Wide top-entry design for easier loading",
      "Rounded dome shape for a comfortable interior",
      "Multiple ventilation panels for optimal airflow",
      "Secure locking mechanism for safe transport",
      "Suitable for routine trips when correctly secured",
      "Durable construction withstands travel rigors",
    ],
  },
  {
    id: 12,
    name: "Petoutlet Basic Litter Box",
    category: "Litter",
    price: "41.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/petoutlet-12-front.png",
    images: ["/img/petoutlet-12-front.png", "/img/petoutlet-12-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Gray", "Blue"],
    material: "Durable plastic",
    description: [
      "The Petoutlet Basic Litter Box is a simple, practical litter box designed to provide cats with a comfortable and accessible place to do their business.",
      "Made from durable, easy-to-clean plastic, this litter box is built to withstand daily use and regular scooping.",
      "The standard open design allows cats easy entry and exit, making it suitable for cats of all ages and sizes.",
      "The high sides help contain litter scatter, keeping the surrounding area cleaner and reducing the frequency of floor sweeping.",
      "Available in multiple sizes to accommodate single cats or multi-cat households with different space requirements.",
      "The smooth interior surface makes scooping and cleaning quick and hassle-free, helping maintain proper hygiene.",
    ],
    Features: [
      "Durable plastic construction for long-lasting use",
      "High sides help contain litter scatter",
      "Open design for easy cat access",
      "Easy to scoop and clean",
      "Available in multiple sizes for different cat needs",
      "Affordable and practical everyday solution",
    ],
  },
  {
    id: 13,
    name: "Petoutlet WeatherSeal Pet Door",
    category: "Accessories",
    price: "193.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/petoutlet-13-front.png",
    images: ["/img/petoutlet-13-front.png", "/img/petoutlet-13-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Indigo", "Blue"],
    material: "Durable plastic with magnetic closure",
    description: [
      "The Petoutlet WeatherSeal Pet Door is designed to give cats and small dogs convenient access while helping reduce drafts.",
      "Featuring a durable plastic frame with a flexible, transparent flap, this pet door provides a secure barrier against wind, rain, and insects.",
      "The magnetic closure ensures the flap seals tightly after your pet passes through, maintaining indoor temperature and energy efficiency.",
      "The WeatherSeal Pet Door can be fitted to suitable doors or panels when installed according to the supplied instructions.",
      "The transparent flap design allows pets to see through to the other side, reducing hesitation and encouraging use.",
      "Available in multiple sizes to accommodate cats and small to medium-sized dogs comfortably.",
    ],
    Features: [
      "Durable plastic frame with flexible transparent flap",
      "Magnetic closure seals out drafts, rain, and insects",
      "Transparent flap helps pets see through and reduces hesitation",
      "Suitable for installation in doors, walls, or panels",
      "Available in multiple sizes for cats and small dogs",
      "Promotes pet independence and freedom",
    ],
  },
  {
    id: 14,
    name: "Petoutlet WeatherGuard Dog House",
    category: "Beds",
    price: "1205.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/petoutlet-14-front.png",
    images: ["/img/petoutlet-14-front.png", "/img/petoutlet-14-angle.png"],
    size: ["Small", "Medium", "Large", "X-Large"],
    colors: ["Indigo", "Gray"],
    material: "Durable plastic and insulated foam",
    description: [
      "The Petoutlet WeatherGuard Dog House is a modern outdoor shelter designed to provide dogs with a comfortable resting place.",
      "Constructed from durable plastic with insulated walls, this dog house helps protect pets from harsh sun, rain, and cold temperatures.",
      "The elevated floor design keeps the interior dry and comfortable by preventing moisture from seeping through the base.",
      "The contemporary deep-blue color blends with modern outdoor spaces while the sturdy construction supports regular use.",
      "Easy to clean and maintain, the Petoutlet WeatherGuard Dog House is made for sheltered outdoor settings.",
      "A cozy retreat for dogs to rest and relax outdoors, providing them with their own safe and sheltered space.",
    ],
    Features: [
      "Insulated walls for year-round weather protection",
      "Elevated floor keeps interior dry and comfortable",
      "Durable plastic construction withstands outdoor elements",
      "Modern deep-blue design complements outdoor spaces",
      "Easy to clean and maintain",
      "Available in multiple sizes for different dog breeds",
    ],
  },
  {
    id: 15,
    name: "Petoutlet Wave Cat Scratcher Lounge",
    category: "Scratchers",
    price: "1928.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/petoutlet-15-front.png",
    images: ["/img/petoutlet-15-front.png", "/img/petoutlet-15-angle.png"],
    size: ["Small", "Large", "Jumbo"],
    colors: ["Natural", "Beige"],
    material: "Recycled corrugated cardboard",
    description: [
      "The Petoutlet Wave Cat Scratcher Lounge is an extra-large scratcher designed to support natural scratching and relaxed lounging.",
      "Made from 100% recycled corrugated cardboard, this eco-friendly scratcher is both sustainable and highly effective at satisfying cats' natural scratching needs.",
      "The curved lounge design encourages cats to stretch, scratch, and relax in a natural, ergonomically comfortable position.",
      "Reversible design allows both sides to be used, effectively doubling the lifespan of the scratcher before replacement is needed.",
      "The jumbo size accommodates multiple cats or larger breeds, making it a versatile addition to any cat-friendly home.",
      "Helps protect furniture by redirecting scratching behavior to a more appropriate and satisfying surface.",
    ],
    Features: [
      "Jumbo-sized curved lounge for stretching and relaxing",
      "100% recycled corrugated cardboard construction",
      "Reversible design doubles the usable life",
      "Satisfies natural scratching instincts",
      "Protects furniture by redirecting scratching behavior",
      "Eco-friendly and sustainable materials",
    ],
  },
  {
    id: 16,
    name: "Petoutlet Top Entry Litter Box Liners",
    category: "Litter",
    price: "77.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/petoutlet-16-front.png",
    images: ["/img/petoutlet-16-front.png", "/img/petoutlet-16-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Blue", "Gray"],
    material: "Disposable plastic liner",
    description: [
      "Petoutlet Top Entry Litter Box Liners are disposable liner bags designed to fit inside top-entry litter boxes for easier cleanup and improved hygiene.",
      "The disposable design eliminates the need to scrub and clean the litter box interior, simply lift out the liner and replace it with a fresh one.",
      "Helps keep the litter box cleaner for longer by preventing waste from sticking to the interior surfaces.",
      "The durable plastic material is designed to resist tears and punctures from cat claws during normal use.",
      "Available in packs of multiple liners, providing excellent value for cat owners who want a more convenient litter box maintenance routine.",
      "An ideal solution for busy pet owners looking to reduce the time and effort spent on litter box cleaning.",
    ],
    Features: [
      "Disposable liner for quick and easy litter box cleaning",
      "Eliminates need to scrub litter box interior",
      "Durable plastic resists tears and punctures",
      "Keeps litter box cleaner for longer periods",
      "Available in multiple sizes and packs",
      "Convenient solution for busy cat owners",
    ],
  },
  {
    id: 17,
    name: "Petoutlet Everyday Pet Porter",
    category: "Kennels",
    price: "964.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/petoutlet-17-front.png",
    images: ["/img/petoutlet-17-front.png", "/img/petoutlet-17-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Blue", "Black"],
    material: "Durable plastic with metal door",
    description: [
      "The Petoutlet Everyday Pet Porter is a versatile plastic carrier designed for comfortable transport of small to medium-sized pets.",
      "Featuring ventilation holes on all sides and a sturdy metal front door, this carrier provides excellent airflow and visibility for your pet.",
      "Before any air journey, confirm the carrier size and current transport rules directly with the airline.",
      "Easy-grip handle and lightweight construction make carrying your pet comfortable and convenient during trips to the vet, park, or travel.",
      "The secure door latch keeps your pet safely contained during transport while allowing easy access for loading and unloading.",
      "A durable, dependable carrier that combines safety, ventilation, and ease of use for everyday pet transport needs.",
    ],
    Features: [
      "All-around ventilation for optimal airflow",
      "Sturdy metal front door with secure latch",
      "Designed for secure routine pet transport",
      "Lightweight with comfortable carrying handle",
      "Excellent visibility through ventilation holes and door",
      "Durable construction for everyday use",
    ],
  },
  {
    id: 18,
    name: "Petoutlet Gravity Pet Waterer With Fresh Filter",
    category: "Waterers",
    price: "201.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/petoutlet-18-front.png",
    images: ["/img/petoutlet-18-front.png", "/img/petoutlet-18-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Gray", "White"],
    material: "Food-safe plastic with replaceable carbon filter",
    description: [
      "The Petoutlet Gravity Pet Waterer is a gravity-fed dispenser that maintains a ready supply of water for cats and dogs.",
      "A replaceable carbon filter helps reduce common taste and odor in the water supply.",
      "The large reservoir holds ample water and automatically refills the bowl as your pet drinks, ensuring a constant supply of fresh water throughout the day.",
      "The food-safe plastic construction is easy to clean, making it a practical choice for everyday pet hydration.",
      "The large reservoir reduces the frequency of refilling while keeping water available throughout the day.",
      "The sturdy, tip-resistant base ensures the waterer stays in place during use, preventing spills and messes on floors.",
    ],
    Features: [
      "Gravity-fed design provides continuous fresh water supply",
      "Replaceable carbon filter helps reduce taste and odor",
      "Large water reservoir reduces frequency of refilling",
      "Food-safe plastic construction",
      "Tip-resistant base prevents spills and messes",
      "Ideal for keeping pets hydrated throughout the day",
    ],
  },
  {
    id: 19,
    name: "Petoutlet Monster Squeaker Dog Toy",
    category: "Toys",
    price: "81.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/petoutlet-19-front.png",
    images: ["/img/petoutlet-19-front.png", "/img/petoutlet-19-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Purple", "Green"],
    material: "Durable rubber with squeaker",
    description: [
      "The Petoutlet Monster Squeaker Dog Toy is a fun, quirky toy designed to capture attention with its playful original shape.",
      "Made from durable rubber, this toy is built to withstand enthusiastic chewing and active play sessions with dogs of all sizes.",
      "The built-in squeaker adds an exciting sound element that keeps dogs engaged and eager to play.",
      "Despite its intimidating name and appearance, the toy is designed with soft enough edges to be gentle on a dog's mouth and teeth.",
      "Perfect for interactive play sessions or as a solo chew toy to keep dogs entertained when owners are away.",
      "The vibrant colors make it easy to locate during outdoor play, while the durable construction ensures long-lasting fun.",
    ],
    Features: [
      "Durable rubber construction for aggressive chewers",
      "Built-in squeaker for added play excitement",
      "Unique quirky design to capture dog's attention",
      "Gentle on teeth and gums during chewing",
      "Vibrant colors for easy visibility during play",
      "Suitable for interactive and solo play",
    ],
  },
  {
    id: 20,
    name: "Petoutlet Crock Bowl For Pets",
    category: "Bowls",
    price: "41.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/petoutlet-20-front.png",
    images: ["/img/petoutlet-20-front.png", "/img/petoutlet-20-angle.png"],
    size: ["Small", "Medium", "Large"],
    colors: ["Blue", "Red"],
    material: "Stoneware ceramic",
    description: [
      "The Petoutlet Crock Bowl is a heavy-duty stoneware ceramic feeding bowl designed to stay in place during mealtime and resist tipping and spilling.",
      "The natural weight of stoneware ceramic prevents the bowl from sliding across the floor as your pet eats, creating a more peaceful mealtime experience.",
      "The glazed ceramic surface is non-porous, easy to clean, and resistant to bacterial buildup, promoting better pet hygiene.",
      "The classic design complements any home decor while the durable construction ensures years of reliable everyday use.",
      "Dishwasher safe for convenient cleaning, and the chip-resistant glaze maintains the bowl's appearance through repeated washing.",
      "An ideal choice for fast-eating dogs, as the stable base encourages a calmer, more controlled eating pace.",
    ],
    Features: [
      "Heavy-duty stoneware ceramic stays in place during meals",
      "Non-porous glazed surface resists bacteria buildup",
      "Dishwasher safe for easy cleaning",
      "Chip-resistant glaze for long-lasting appearance",
      "Stable base prevents tipping and spillage",
      "Encourages slower, calmer eating habits",
    ],
  },
];

export default productData;
